
import { Component, Prop, Vue } from 'vue-property-decorator'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'
import DashboardButton from '~/components/common/buttons/DashboardButton.vue'
import Icon from '~/components/common/icon/Icon.vue'

const MODAL_NAME = 'LoopGuestShareModal'

@Component({
  name: 'LoopGuestShareModal',
  components: {
    CloseCrossCtrl,
    DashboardButton,
    Icon
  }
})
export default class LoopGuestShareModal extends Vue {
  @Prop({ type: String, required: true }) readonly shareUrl!: string

  closeModal = () => {
    this.$mixpanel.track(this.$mixpanel.events.GUEST_GIFT_POPUP_CLOSED)
    this.$modal.hide(MODAL_NAME)
  }

  handleCopyClick = () => {
    this.$mixpanel.track(this.$mixpanel.events.GUEST_GIFT_LINK_COPIED)
    window.alert('Link copied!')
  }
}
